import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { useParams } from 'react-router-dom';
import s from './UnitOverview.module.scss';
import modelImg from '../../assets/model.svg';
import stateImg from '../../assets/state.svg';
import locationImg from '../../assets/locationdot.svg';
import CommandPanel from '../CommandPanel/CommandPanelContainer';
import { push } from 'redux-first-history';
import { Row, Col, Card, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import ContentTemplate from '../ContentTemplate/ContentTemplate';
import { getUnitManager, getUnitOverview, getUserProfileWidget, getFlowSequenceSetpoints, getCurrentTimezone } from '../../selectors/index';
import { getUnitOverviewSettingsThunk, getUnitOverviewDataThunk, cleanUpThunk } from '../../actions/unitOverview'
import { initialUnitOverview } from '../../reducers/initialState';
import SystemAlerts from './SubComponents/SystemAlerts';
import SummaryTypeStyle1 from './SubComponents/SummaryTypeStyle1';
import SummaryTypeStyle2 from './SubComponents/SummaryTypeStyle2';
import TableStyleGroup from './SubComponents/TableStyleGroup';
import { setPageFilter } from '../../actions/alarms';
import { COLORS, toCamelCaseWithSpaces, toUpperCaseWithSpaces } from './Utils/generalUtil';
import { Wifi, WifiOff } from 'react-bootstrap-icons';
import DashboardGraph from './SubComponents/DashboardGraph';
import { FormattedMessage, injectIntl } from 'react-intl';
import { GradientSlider } from './SubComponents/GradientSlider';

const UnitOverview = ({ intl }) => {

  let widgetCode = 'UNITOVERVIEW';


  const userProfileWidgets = useSelector(state => getUserProfileWidget(state));
  const unitManager = useSelector(state => getUnitManager(state));
  const flowSequences = useSelector(state => getFlowSequenceSetpoints(state))
  const unitOverview = useSelector(state => getUnitOverview(state));
  const currentTimezone = useSelector(state => getCurrentTimezone(state));
  const dispatch = useDispatch();
  const redirect = location => push(location);
  // State for various metrics and system status
  const [currentTime, setCurrentTime] = useState(new Date());
  const { unitSerialNumber } = useParams();

  const selectedUnit = unitManager.selectedUnit || {};
  let waterQuality = unitOverview.Data.WaterQuality || {};
  let unitStatus = unitOverview.Data.UnitStatus || {};
  let telemetryData = unitOverview.Data.Telemetry || [];
  const lastTelemetryTimestamp = unitOverview.Data.LastTelemetryTimestamp || null;
  const lastSummaryTimestamp = unitOverview.Data.LastSummaryTimestamp || null;


  useEffect(() => {
    if (selectedUnit.ModelId != 0 && selectedUnit.UnitId != 0 && selectedUnit.UnitSerialNumber != '' && unitSerialNumber == selectedUnit.UnitSerialNumber) {

      dispatch(getUnitOverviewSettingsThunk(widgetCode, { modelId: selectedUnit.ModelId, unitId: selectedUnit.UnitId, unitSerialNumber: selectedUnit.UnitSerialNumber }));
    }
  }, [getUnitOverviewSettingsThunk, selectedUnit.ModelId, selectedUnit.UnitId, selectedUnit.UnitSerialNumber, unitSerialNumber, dispatch]);


  useEffect(() => {
    return () => {
      dispatch(
        cleanUpThunk({
          ...initialUnitOverview.UnitOverview
        })
      );
    };
  }, []);

  const onAlarmClick = (status) => {
    let alarmFilter = {
      filterModelCategory: selectedUnit.ModelCategoryId || 0,
      filterUnit: selectedUnit.UnitId,
      filterStatus: status
    }
    dispatch(setPageFilter(alarmFilter))
    dispatch(redirect(`/alarms`));
  };



  // Simulate real-time data updates
  useEffect(() => {
    if (selectedUnit.UnitSerialNumber == '' || unitSerialNumber !== selectedUnit.UnitSerialNumber) return;
    const timer = setInterval(() => {
      setCurrentTime(new Date());

      const lastTelemetryTimestamp = unitOverview.Data.LastTelemetryTimestamp || null;
      dispatch(getUnitOverviewDataThunk(widgetCode, { modelId: selectedUnit.ModelId, unitId: selectedUnit.UnitId, unitSerialNumber: selectedUnit.UnitSerialNumber, LastTelemetryTimestamp: lastTelemetryTimestamp, LastSummaryTimestamp: lastSummaryTimestamp }));

    }, 10000);

    return () => clearInterval(timer);
  }, [selectedUnit.ModelId, selectedUnit.UnitId, selectedUnit.UnitSerialNumber, lastTelemetryTimestamp, lastSummaryTimestamp, unitSerialNumber, dispatch]);

  const alarmStatus = () => {
    let status = '';
    if (unitOverview.Data.Alarms.TotalAlarms > 0) {
      status = 'needs attention';
    } else {
      status = 'normal';
    }
    return status;
  }

  const groupStatusResults = () => {
    let localStatuses = []
    if (unitOverview.Dashboard.DashboardGroups.length > 0) {
      unitOverview.Dashboard.DashboardGroups.forEach(mg => {

        mg.SubGroups && mg.SubGroups.forEach(sg => {
          if (sg.EvaluatedGroupStatus) {

            localStatuses.push(sg.EvaluatedGroupStatus);
          }
        });

        if (mg.EvaluatedGroupStatus) {
          localStatuses.push(mg.EvaluatedGroupStatus);
        }
      });
    }
    return getStatus(localStatuses);

  }

  const subGroupStatusResults = () => {
    let localStatuses = []

    unitOverview.Dashboard && unitOverview.Dashboard.DashboardDetails &&
      unitOverview.Dashboard.DashboardDetails
        .filter(dd => dd.PlaceholderType === 'Group')
        .map((dd, index) => dd.EvaluatedStatus && localStatuses.push(dd.EvaluatedStatus));

    return getSystemStatus(localStatuses);

  }

  const systemStatus = () => {
    let allStatus = [alarmStatus(), getWaterQualityStatus(waterQuality.status), groupStatusResults(), subGroupStatusResults()];

    return getSystemStatus(allStatus);
  }

  const currentUnitStatus = () => {
    let sequenceStatus = unitStatus.SequenceGroupName || unitStatus.SequenceName || unitStatus.Code || 'Unknown';

    return { status: sequenceStatus, statusType: 'unit_status', sequenceCode: unitStatus.SequenceCode || 0, toolTip: unitStatus.ToolTip || '' };
  }

  const SystemOnlineStatus = () => {
    let onlineStatusObj = unitOverview.Dashboard && unitOverview.Dashboard.SystemStatus || {};
    let onlineStatus = onlineStatusObj.status || 'Unknown'
    let statusClass = onlineStatusObj.isOnline ? 'success' : 'danger';
    return (
      <div className={`px-3 py-1 rounded-pill d-flex align-items-center`}>
        {onlineStatusObj.isOnline ? <Wifi className={`text-${statusClass} me-1`} size={25} /> : <WifiOff className={`text-${statusClass} me-1`} size={25} />}
        <span className={`text-${statusClass} fs-5`}>  {onlineStatus}</span>
      </div>
    )
  }



  return (
    <div className={s.unitOverview}>
      {unitOverview.isLoading && unitOverview.initialLoading && <LoadingSpinner />}
      {/* <Banner failureText={messageText} showBanner={displayBanner} status={opStatus} successText={messageText} /> */}
      <ContentTemplate
        selectedPage="unitOverview"
        backLink="/overview"
        userProfileWidgets={userProfileWidgets}
        widgetCode={widgetCode}
        tagoutRequired={true}
      >
        <div className={s.contentWrapper}>
          <div>
            <Card.Body>
              {/* Header */}

              {/* System Status Indicators */}

              <div className="d-flex flex-wrap px-4  rounded justify-content-end">
                <div className="d-flex align-item">
                  <SystemOnlineStatus />
                </div>
              </div>
              <div className="mb-2 justify-content-between">
                <h3 className={`${s.subHeading} fw-bold text-secondary`}> <FormattedMessage id="unitOverview.last24hours" defaultMessage="Performance (Past 24 Hours)" /></h3>
              </div>

              {/* Main content */}
              <Row>
                <Col xxl={7} xl={6} lg={12} md={12} className={`${s.pr2} d-flex flex-column`}>
                  {unitOverview.Dashboard.DashboardDetails && <Style2ComponentSection dashboardDetails={unitOverview.Dashboard.DashboardDetails} />}

                  <Card className="shadow p-2 mb-4">
                    <Card.Body>
                      <Row >

                        <Col lg={12} md={12} sm={12} className="position-relative">

                          <div className="d-flex justify-content-between mb-3">
                            <h4 className={`fw-bold ${s.subHeading}`}><FormattedMessage id="unitOverview.systemOperations" defaultMessage="System Operations" /></h4>
                            <span className="small text-secondary"></span>
                          </div>
                        </Col>
                        <Col className='text-center'>
                          <CommandPanel flowSequences={flowSequences} userProfileWidgets={userProfileWidgets} showAllCommands={false} />
                        </Col>

                      </Row>
                    </Card.Body>
                  </Card>

                  {unitOverview && unitOverview.Data && unitOverview.Data.Alarms && (
                    <SystemAlerts alarms={unitOverview.Data.Alarms} onAlarmClick={onAlarmClick} currentTimezone={currentTimezone} />
                  )}

                  {unitOverview.Dashboard.DashboardDetails && <Style1ComponentSection dashboardDetails={unitOverview.Dashboard.DashboardDetails} isLoading={(unitOverview.isLoading && unitOverview.initialLoading)} />}

                </Col>
                {/* <Col md={4} className={s.pr2}>
                  {unitOverview.Dashboard.DashboardDetails && <GraphsComponentSection dashboardDetails={unitOverview.Dashboard.DashboardDetails} data={telemetryData} currentTimezone={currentTimezone} />}
                </Col> */}

                <Col xxl={5} xl={6} lg={6} md={12} sm={12} className={`${s.pr2} d-flex flex-column`}>
                  {/* Device Information Card */}
                  {getUnitDetails()}

                  <Card className="mb-4 shadow py-3 px-4 flex-grow-1">
                    <Card.Body>
                      <Row >
                        <div className="d-flex justify-content-between mb-3">
                          <h4 className={`fw-bold ${s.subHeading}`}><FormattedMessage id="unitOverview.unitStatus" defaultMessage="Unit Status" /></h4>
                          <span className="small text-secondary"></span>
                        </div>

                        <Col lg={12} md={12} sm={12} className="position-relative">
                          {getGroupStatus(currentUnitStatus, systemStatus, alarmStatus, selectedUnit, waterQuality, unitOverview)}
                        </Col>
                      </Row>
                    </Card.Body>

                  </Card>

                  {unitOverview.Dashboard.DashboardGroups && unitOverview.Dashboard.DashboardGroups.map(mg => {
                    return <TableStyleGroup key={mg.UnitDashboardGroupId} dashboardGroup={mg} />
                  }
                  )}


                </Col>

                {/* <Col xxl={4} xl={6} lg={6} md={12} sm={12} style={{ paddingBottom: '30px' }}> */}
                {/* Alert panel - only shown if there are alarms */}


                {/* </Col> */}


              </Row>
            </Card.Body>
          </div>
        </div>
      </ContentTemplate>
    </div>
  );

  function getUnitDetails() {
    return <Card className="mb-4  shadow" style={{ borderRadius: '0.375rem 0.375rem 0.375rem 0.375rem', padding: '10px' }}>
      <Card.Body className="pb-4">
        <Row>

          <Col md={12} sm={12} className="position-relative">

            {/* Lock Icon in top right */}

            <div className="position-absolute" style={{ top: '15px', right: '15px' }}>
              <i className="text-primary bi bi-lock-fill" style={{ fontSize: '24px' }}></i>
            </div>

            {/* Device ID */}
            <h4 className="mb-1 ml-0 fw-bold">{selectedUnit.Name}</h4>
            <p className="text-secondary mb-4 fs-5">{`${selectedUnit.UnitSerialNumber}`}</p>
            {/* Gateway info with icon */}
            <div className="d-flex align-items-center mb-2">
              <div className="me-2" style={{ width: '24px', height: '24px' }}>
                <img src={modelImg} />
              </div>
              <span className='fs-5'>{selectedUnit.ModelName}</span>
            </div>

            {/* Location with icon */}
            <div className="d-flex align-items-center mb-3">
              <div className="me-2" style={{ width: '24px', height: '24px' }}>
                <img src={locationImg} />
              </div>
              <span className='fs-5'>{`${selectedUnit.InstallationCity || "Unknown"}, ${selectedUnit.InstallationCountry || "-"}`}</span>
            </div>

            {/* Tag */}
            {/* <div className="mb-3">
              <div className="d-flex align-items-center">
                <div className="me-2" style={{ width: '24px', height: '20px' }}>
                  <img src={stateImg} />
                </div>

                <div className="bg-info bg-opacity-10 text-info px-3 py-1 rounded-pill">
                  {unitStatus.SequenceGroupName || unitStatus.SequenceName || unitStatus.Code || '-'}
                </div>
              </div>
            </div> */}

          </Col>

        </Row>
      </Card.Body>
    </Card>;
  }
};

export default UnitOverview;

export const WaterQualityStatusIndicator = ({ status, label }) => {
  let dotColor = '';
  switch (status.toLowerCase()) {
    case 'good':
      dotColor = COLORS.GREEN; // Green color
      break;
    case 'poor':
      dotColor = COLORS.RED // Yellow/amber color
      break;

    default:
      dotColor = COLORS.GRAY // Gray color
  }
  return (
    // <div className="d-flex align-items-center me-4">
    //   <div
    //     className="me-2"
    //     style={{
    //       width: '16px',
    //       height: '16px',
    //       borderRadius: '50%',
    //       backgroundColor: dotColor
    //     }}
    //   />
    //   <span>{label}: {toCamelCaseWithSpaces(status)}</span>
    // </div>
    <Row className="py-2 px-1 mb-3 align-items-center border-bottom">
      <Col xs={6} className="text-muted fs-5 d-flex align-items-center">{label}</Col>
      <Col xs={6}>
        <div

          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            marginRight: '8px',
            backgroundColor: dotColor
          }}
        />
        <span className='fs-5'>{toCamelCaseWithSpaces(status)}  </span>
      </Col>
    </Row>
  );
}

// Status indicator component
const LabelWithTooltip = ({ label, tooltip }) => {
  if (!tooltip) return <span>{label}</span>;
  return (
    <>
      {label}{' '}
      <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
        <span style={{ cursor: 'pointer', color: '#0d6efd', fontSize: '1.3em', lineHeight: 1 }}>&#9432;</span>
      </OverlayTrigger>
    </>
  );
};

export const StatusIndicator = ({ status, label, statusType = "standard", value = null, uom = null, tooltip = null }) => {
  let dotColor = '';
  const isSpanExists = (str) => !!str && /<span[\s\S]*?>[\s\S]*?<\/span>/i.test(str);

  if (statusType.toLowerCase() === 'standard' || statusType.toLowerCase() === 'group') {
    switch (status.toLowerCase()) {
      case 'online':
      case 'excellent':
      case 'good':
      case 'normal':
      case 'not empty':
      case 'sufficient':
      case 'available':
      case ' ': // Treat blank status as good/normal
        dotColor = COLORS.GREEN; // Green color
        break;
      case 'warning':
      case 'moderate':
        dotColor = COLORS.YELLOW; // Yellow/amber color
        break;
      case 'poor':
        dotColor = COLORS.ORANGE // Yellow/amber color
        break;
      case 'critical':
      case 'offline':
      case 'needs attention':
      case 'empty':
      case 'insufficient':
      case 'reorder':
      case 'replace':
      case '<span>reorder</span>':
      case '<span>replace</span>':
      case '<span>refill to restart</span>':
      case '<span>refill</span>':
      case 'fault':
        dotColor = COLORS.RED  // Red color
        break;
      default:
        dotColor = COLORS.GRAY // Gray color
    }
  } else if (statusType.toLowerCase() === 'unit_status') {
    switch (status.sequenceCode) {
      case 2076:
        dotColor = COLORS.YELLOW; // Yellow color
        break;
      case 2020:
        dotColor = COLORS.RED; // Red color
        break;
      default:
        dotColor = COLORS.GREEN // Green color
    }
    status = status.status || 'Unknown';

  }
  value = value !== null && typeof value === 'number' ? Math.round(value) : value;

  if (uom === '%') {
    return (
      <Row className="py-2 px-1 border-bottom" style={{ minHeight: '74px' }}>
        <Col xs={12}>
          <div className="text-muted fs-5 mb-3 d-flex justify-content-between align-items-center">
            <span><LabelWithTooltip label={label} tooltip={tooltip} /></span>
            {isSpanExists(status) && <BadgeLabel text={status} />}
          </div>
          <GradientSlider value={value} amberStart={25} greenStart={75} onChange={() => { }} />
        </Col>
      </Row>
    );
  }

  return (
    <Row className="py-2 px-1 align-items-center border-bottom" style={{ minHeight: '74px' }}>
      <Col xs={6} className="text-muted fs-5"><LabelWithTooltip label={label} tooltip={tooltip} /></Col>
      <Col xs={6}>
        <div
          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            marginRight: '8px',
            backgroundColor: dotColor
          }}
        />
        <span className='fs-5'> {statusType != "standard" && statusType != 'unit_status' && `${(value ?? '_')}${(uom ?? '')} `}
          {(statusType == "standard" || statusType == 'unit_status' || isSpanExists(status)) && <BadgeLabel text={status} />}
        </span>
      </Col>
    </Row>
  );
};


// Status indicator component
export const StatusIndicatorIndividual = ({ status, label, statusType = "individual", value = null, uom = null, tooltip = null }) => {
  let dotColor = '';
  let statusColor = status && status != '-' && status || value;
  statusColor = statusColor || 'Unknown';
  switch (statusColor.toLowerCase()) {
    case 'yes':
    case 'excellent':
    case 'good':
    case 'normal':
    case 'not empty':
    case 'sufficient':
    case 'available':
    case ' ': // Treat blank status as good/normal
      dotColor = COLORS.GREEN; // Green color
      break;
    case 'warning':
    case 'moderate':
      dotColor = COLORS.YELLOW; // Yellow/amber color
      break;
    case 'poor':
      dotColor = COLORS.ORANGE // Yellow/amber color
      break;
    case 'critical':
    case 'offline':
    case 'needs attention':
    case 'empty':
    case 'insufficient':
    case 'fault':
    case 'reorder':
    case 'replace':
    case '<span>reorder</span>':
    case '<span>replace</span>':
    case '<span>refill</span>':
    case '<span>refill to restart</span>':
      dotColor = COLORS.RED  // Red color
      break;
    default:
      dotColor = COLORS.GRAY // Gray color

  }
  value = value !== null && typeof value === 'number' ? Math.round(value) : value;
  return (
    <Row className="py-2 px-1 align-items-center border-bottom" style={{ minHeight: '74px' }}>
      <Col xs={6} className="text-muted fs-5"><LabelWithTooltip label={label} tooltip={tooltip} /></Col>
      <Col xs={6}>
        <div
          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            marginRight: '8px',
            backgroundColor: dotColor
          }}
        />
        <span className='fs-5'> {`${(value ?? '_')}${(uom ?? '')} `}
          {BadgeLabel(status)}</span>
      </Col>
    </Row>
  );
};



const BadgeLabel = ({ text = "" }) => {
  // Detects if a string contains any <span>...</span> tags
  const containsSpanTag = (str) => /<span[\s\S]*?>[\s\S]*?<\/span>/i.test(str);
  // Strips HTML tags for safe display in the badge
  const stripTags = (str) => str.replace(/<[^>]*>/g, "");

  const isHighlighted = containsSpanTag(text);
  const displayText = stripTags(text);



  if (!isHighlighted) {
    return <span>{toCamelCaseWithSpaces(text)}</span>;
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 10px",
        borderRadius: "9999px",
        fontSize: "0.75rem",
        fontWeight: 600,
        letterSpacing: "0.04em",
        fontFamily: "'DM Mono', 'Fira Code', monospace",
        userSelect: "none",
        backgroundColor: "#dc2626",
        color: "#ffffff",
        boxShadow: "0 1px 4px rgba(220,38,38,0.35)",
      }}
    >
      {toUpperCaseWithSpaces(displayText)}
    </span>
  );
};

const getWaterQualityStatus = (status) => {
  if (status.toLowerCase() == 'good') {
    return 'Good';
  } else if (status.toLowerCase() == 'poor') {
    return 'Poor';
  } else if (status.toLowerCase() == 'restarting') {
    return 'Restarting';
  } else {
    return 'Unknown';
  }
};

const getStatus = (statuses) => {
  const lowercased = statuses.map(s => s.toLowerCase());

  if (lowercased.some(s => ['needs attention', 'critical'].includes(s))) {
    return 'Needs Attention';
  } else if (lowercased.includes('poor')) {
    return 'Poor';
  } else if (lowercased.some(s => ['warning', 'moderate'].includes(s))) {
    return 'Warning';
  } else if (lowercased.some(s => ['online', 'normal', 'good', 'excellent'].includes(s))) {
    return 'Normal';
  } else {
    return 'Unknown';
  }
};

const getSystemStatus = (statuses) => {
  const lowercased = statuses.map(s => s.toLowerCase());

  if (lowercased.some(s => ['needs attention', 'critical', 'poor', 'fault'].includes(s))) {
    return 'Fault';
  } else if (lowercased.some(s => ['online', 'normal', 'good', 'excellent'].includes(s))) {
    return 'Good';
  } else {
    return 'Unknown';
  }
};


const Style1ComponentSection = ({ dashboardDetails = { initialUnitOverview }, isLoading = true }) => {
  const rows = [];
  dashboardDetails = dashboardDetails.filter(item => item.PlaceholderType == 'SummaryTypeStyle1') || [];
  const sortedDetails = [...dashboardDetails].sort((a, b) => a.SortOrder - b.SortOrder);

  for (let i = 0; i < sortedDetails.length; i += 2) {
    rows.push(
      <Row key={`row-${i}`} className={`${s.cardMH}`} >
        <Col lg={6} md={6} sm={6} xs={12} className={`mb-3`}>
          <SummaryTypeStyle1 dashboardDetail={sortedDetails[i]} isLoading={isLoading} />
        </Col>
        {i + 1 < sortedDetails.length && (
          <Col lg={6} md={6} sm={6} xs={12} className={`mb-3`}>
            <SummaryTypeStyle1 dashboardDetail={sortedDetails[i + 1]} isLoading={isLoading} />
          </Col>
        )}
      </Row>
    );
  }

  return rows;
};

const Style2ComponentSection = ({ dashboardDetails }) => {
  const rows = [];
  dashboardDetails = dashboardDetails.filter(item => item.PlaceholderType == 'SummaryTypeStyle2') || [];
  const sortedDetails = [...dashboardDetails].sort((a, b) => a.SortOrder - b.SortOrder);

  for (let i = 0; i < sortedDetails.length; i += 3) {
    rows.push(
      <Row key={`row-${i}`} className={`${s.cardMH} mb-0`} >
        <Col md={4} sm={4} xs={12} className="mb-0">
          <SummaryTypeStyle2 dashboardDetail={sortedDetails[i]} />
        </Col>
        {i + 1 < sortedDetails.length && (
          <Col md={4} sm={4} xs={12} className="mb-0">
            <SummaryTypeStyle2 dashboardDetail={sortedDetails[i + 1]} />
          </Col>
        )}
        {i + 2 < sortedDetails.length && (
          <Col md={4} sm={4} xs={12} className="mb-0">
            <SummaryTypeStyle2 dashboardDetail={sortedDetails[i + 2]} />
          </Col>
        )}
      </Row>
    );
  }

  return rows;
};

const GraphsComponentSection = ({ dashboardDetails, data, currentTimezone }) => {
  const rows = [];
  dashboardDetails = dashboardDetails.filter(item => item.PlaceholderType == 'Graph') || [];
  const sortedDetails = [...dashboardDetails].sort((a, b) => a.SortOrder - b.SortOrder);

  for (let i = 0; i < sortedDetails.length; i += 1) {
    rows.push(
      <Row key={`row-${i}`} className={`${s.cardMH} mb-4`} >
        <Col sm={12}>
          <DashboardGraph dashboardDetail={sortedDetails[i]} data={data} currentTimezone={currentTimezone} />
        </Col>
      </Row>
    );
  }

  return rows;
};

const GroupStatus = ({ unitOverviewGroups }) => {
  let localGroupStatuses = []
  if (unitOverviewGroups.length > 0) {
    unitOverviewGroups.forEach(mg => {

      mg.SubGroups && mg.SubGroups.forEach(sg => {
        if (sg.EvaluatedGroupStatus) {
          localGroupStatuses.push({ Name: sg.Name, Status: sg.EvaluatedGroupStatus });
        }
        else {
          localGroupStatuses.push({ Name: sg.Name || '-', Status: 'Unknown' });
        }
      });
      if (mg.EvaluatedGroupStatus) {
        localGroupStatuses.push({ Name: mg.Name || '-', Status: mg.EvaluatedGroupStatus });
      }
    });
  }
  return (
    <Fragment>
      {localGroupStatuses.map((group, index) => (
        <StatusIndicator key={index} status={getStatus([group.Status])} label={group.Name} />
      ))}
    </Fragment>
  )
}


const getGroupStatus = (unitstatus, systemStatus, alarmStatus, selectedUnit, waterQuality, unitOverview) => {
  let currentUnitStatus = unitstatus();
  return <div className="">
    {unitOverview.Dashboard && unitOverview.Dashboard.DashboardDetails &&
      unitOverview.Dashboard.DashboardDetails
        .filter(dd => dd.PlaceholderType === 'Individual')
        .sort((a, b) => a.SortOrder - b.SortOrder)
        .map((dd, index) => <StatusIndicatorIndividual key={index} status={dd.EvaluatedStatus || '-'} label={dd.Name} value={dd.EvaluatedValue} uom={dd.UoM} statusType='Individual' tooltip={dd.ToolTip} />)
    }
    
    <StatusIndicator status={currentUnitStatus} label="Current Operation" statusType="unit_status" tooltip={currentUnitStatus.toolTip} />
    {/* <StatusIndicator status={systemStatus()} label="System Status" /> */}
    {/* <StatusIndicator status={alarmStatus()} label="Alerts" /> */}

    {unitOverview.Dashboard && unitOverview.Dashboard.DashboardDetails &&
      unitOverview.Dashboard.DashboardDetails
        .filter(dd => dd.PlaceholderType === 'Group')
        .sort((a, b) => a.SortOrder - b.SortOrder)
        .map((dd, index) => <StatusIndicator key={index} status={dd.EvaluatedStatus || '-'} label={dd.Name} value={dd.EvaluatedValue} uom={dd.UoM} statusType='group' tooltip={dd.ToolTip} />)
    }
    {unitOverview.Dashboard && unitOverview.Dashboard.DashboardGroups && <GroupStatus unitOverviewGroups={unitOverview.Dashboard.DashboardGroups} />}
  </div>;
}

